"use client";

import React, { useState } from "react";
import { HmcToggle } from "@adi-ctx/harmonic-core-components-react";
import { withHydrationFixed } from "@/components";

type FilterToggleProps = {
	readonly label: string;
	readonly isChecked?: boolean;
	readonly onChange: (checked: boolean) => void;
};

/**
 * Displays a Harmonic Toggle component and calls "onChange" when the user changes its state
 * @constructor
 */
export default function FilterToggle(props: FilterToggleProps) {
	const [isChecked, setIsChecked] = useState(Boolean(props.isChecked));
	const ToggleWithHydrationFixed = withHydrationFixed(HmcToggle);

	const onChanged = ({
		detail: { checked },
	}: {
		detail: { checked: boolean };
	}) => {
		setIsChecked(checked);

		if (typeof props.onChange === "function") {
			props.onChange(checked);
		}
	};

	return (
		<ToggleWithHydrationFixed
			isChecked={isChecked}
			label={props.label}
			data-testid="filter-toggle"
			data-teststatus={isChecked ? "checked" : "unchecked"}
			onChanged={onChanged}
		/>
	);
}
